export enum Platform {
  CASHLINK = 'cashlink',
  TRADIAS = 'tradias',
  WEBZEICHNUNG = 'webzeichnung',
  ARTTRADE = 'arttrade',
  LAIQON = 'laiqon',
  KRYPTOFANTEN = 'kryptofanten',
  IQFAIRPROFIT = 'iqfairprofit',
  IMMVESTIFY = 'immvestify',
  ART360X = 'art360x',
  SENSUS = 'sensus',
  RIDGE = 'ridge',
  AGITAREX = 'agitarex',
  BRIGHTPOINT = 'brightpoint',
  // <PLATFORM_ONBOARDING>{{PLATFORM|upper}}= "{{PLATFORM}}",</PLATFORM_ONBOARDING>
}

export type Platforms = (typeof Platform)[keyof typeof Platform];

export type PlatformType = `${Platform}`;

export const PlatformList = Object.values(Platform);

export interface PlatformConfig {}
